import React, { useState } from "react";
import { ListCard, MapViewFlyOut } from "../Shared";
import { useGetVehiclesQuery } from "../../ManagementPortal/services";
import { useEffect } from "react";
import { FMDPStorage } from "../../../shared/helper";
import { useDispatch } from "react-redux";
import { setSourceIdsGlobal } from "../../../reduxStore/features";
import { getLocalizedString } from "../../../shared/translation";
import { setSelectionRange } from "@testing-library/user-event/dist/utils";
import Scrollbars from "react-custom-scrollbars-2";
import { useSelector } from "react-redux";
import moment from "moment";
import { getUserIdForFiltering } from "../utils";
import sprite from "../../../assets/icons.svg";

let list_arr = [];
export const VehicleList = ({
  setDetails,
  setDeviceId = () => {},
  setSourceIds,
  showPontOnMap,
  mapData,
  setselectedVehiclePlate,
  setHighlight,
  highlight,
  setDockAlign,
  setShowDetails,
  removeLayerOnClose,
  setMapExpand,
  setShowTrack,
  dockAlign,
  setSimpleSearch,
  simpleSearch,
  currentTab,
  setVehicleData,
  selectedRowId,
  setSelectedRowId,
  vehicleData,
  setCurrentTab = () => {},
  vehiclesData = [],
  paginationVehicles,
  totalCountVehicles,
  sortedDataDisplay,
  setSortedDataDisplay,
  plateSort,
  setPlateSort,
  setPageVehicles,
  q,
  setNonAdminUserId,
  nonAdminUserId,
  addNewBox,
  isRefreshing = false,
  // Canonical telemetry getters from `useVehicleTelemetry` in VehicleContainer.
  // Forwarded to ListCard, which consumes them in place of recomputing speed and
  // status from the raw latest-vehicles response (spec task 3.8).
  telemetry,
}) => {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  const currentUser = FMDPStorage.get("current-user");
  const selectedAppId = FMDPStorage.get("selected-app-id");
  const dispatch = useDispatch();
  let globalDockAlign = useSelector((state) => state.common.globalDockAlign);

  // Function to format the timestamp in a human-readable way
  const formatLastUpdated = (timestamp) => {
    if (!timestamp) return "Unknown";

    const now = moment();
    const updateTime = moment(timestamp);
    const diffSeconds = now.diff(updateTime, "seconds");

    if (diffSeconds < 60) {
      return `${diffSeconds} sec${diffSeconds === 1 ? "" : "s"} ago`;
    } else if (diffSeconds < 3600) {
      const mins = Math.floor(diffSeconds / 60);
      return `${mins} min${mins === 1 ? "" : "s"} ago`;
    } else if (diffSeconds < 86400) {
      const hours = Math.floor(diffSeconds / 3600);
      return `${hours} hour${hours === 1 ? "" : "s"} ago`;
    } else {
      return updateTime.format("DD MMM, HH:mm");
    }
  };

  // For page change set the map as default tab
  useEffect(() => {
    setCurrentTab("Map");
    setShowTrack(false);
    setDockAlign("cross");
    setselectedVehiclePlate(null);
  }, [paginationVehicles?.page]);

  const getUserId = () => {
    return getUserIdForFiltering(currentUser, selectedAppId);
  };

  //Set the non admin user id
  useEffect(() => {
    if (sortedDataDisplay) {
      setNonAdminUserId(getUserId());
    }
  }, []);

  const pagination = { page, perPage, onPageChange: setPage, onPerPageChange: setPerPage };

  useEffect(() => {
    setPage(1);
  }, [simpleSearch]);

  // For viewing all vehicles
  const {
    data: coreDevices = { data: [], total_count: 0 },
    error,
    isLoading,
  } = useGetVehiclesQuery(
    {
      page,
      per_page: perPage,
      q,
      filter_user_id: nonAdminUserId,
    },
    { skip: sortedDataDisplay },
  );

  // For viewing vehicles for non admin users
  const { data: devicesList } = useGetVehiclesQuery(
    {
      page,
      per_page: 10000,
      q,
      filter_user_id: nonAdminUserId,
    },
    { skip: nonAdminUserId === "" },
  );

  // If the user is non-admin, store the plate numbers which that particular user has
  useEffect(() => {
    if (nonAdminUserId) {
      FMDPStorage.set(
        "selected-plate-numbers",
        devicesList?.data?.map((device) => {
          return device?.plate_number;
        }),
      );
    }

    if (devicesList?.data?.length > 0) {
      let temp = [];
      devicesList?.data?.map((device) => {
        temp.push(device?.plate_number);
      });
      setSourceIds(temp);
    }
  }, [devicesList]);

  useEffect(() => {
    if (!sortedDataDisplay) {
      try {
        list_arr = [];
        coreDevices?.data.forEach((element, index) => {
          let x = { className: element.plate_number + "_cls" };
          list_arr.push({ ...element, ...x });
        });

        let devices = coreDevices?.data.map(({ plate_number }) => plate_number);
        setSourceIds((prev) => devices);
      } catch (e) {}
    }
  }, [coreDevices.data, simpleSearch, sortedDataDisplay]);

  useEffect(() => {
    try {
      const device_name_list_arr = devicesList?.data?.map((elem, id) => {
        return elem.device_name_list;
      });
      const plate_no_list_arr = devicesList?.data?.map((elem, id) => {
        return elem.plate_number;
      });
      dispatch(setSourceIdsGlobal([device_name_list_arr, plate_no_list_arr]));
    } catch (e) {
      console.log(e);
    }
  }, [devicesList, dispatch]);

  const onRowClick = (data, id) => {
    // Create a unique identifier using both id and plate_number
    const uniqueId = `${data?.id}-${data?.plate_number}`;

    if (selectedRowId === uniqueId) {
      setSelectedRowId(null);
      removeLayerOnClose();
      setDetails(false);
      setDeviceId(null);
      setDockAlign("cross");
      setVehicleData(null);
      setselectedVehiclePlate(null);
    } else {
      setSelectedRowId(uniqueId);
      setDetails(true);
      removeLayerOnClose();
      setDeviceId(data?.device_name_list);
      setselectedVehiclePlate(data?.plate_number);
      setVehicleData(data);
      try {
        showPontOnMap(data?.device_name_list, data?.plate_number);
      } catch (e) {}

      dockAlign === "cross" && setDockAlign(globalDockAlign);

      globalDockAlign === "pop-out" && addNewBox(100);
    }
  };

  useEffect(() => {
    try {
      if (!simpleSearch) {
        setSelectedRowId(null);
        removeLayerOnClose();
        setDetails(false);
        setDeviceId(null);
        setDockAlign("cross");
        setVehicleData(null);
        setselectedVehiclePlate(null);
        setCurrentTab("Map");
      }
    } catch (e) {
      console.log(e);
    }
  }, [paginationVehicles?.page, simpleSearch]);

  const getHeaderList = () => {
    return (
      <header className="qi-list-view_header asset-list_header">
        <div className="qi-list-view_column status" title={getLocalizedString("status", "Status")}>
          {getLocalizedString("status", "Status")}
        </div>
        <div
          className="qi-list-view_column vehicle-id"
          role="columnheader"
          title={getLocalizedString("plate_number", "Plate Number")}
          aria-sort={plateSort === "ASC" ? "ascending" : plateSort === "DESC" ? "descending" : "none"}
        >
          {sortedDataDisplay ? (
            <button
              type="button"
              className={plateSort ? "is-sorted" : ""}
              onClick={() => {
                setPlateSort(plateSort === "ASC" ? "DESC" : plateSort === "DESC" ? "" : "ASC");
                setPageVehicles(1);
              }}
              aria-label={`${getLocalizedString("plate_number", "Plate Number")}: ${plateSort === "ASC" ? "ascending" : plateSort === "DESC" ? "descending" : "default"}. Click to sort`}
            >
              {getLocalizedString("plate_number", "Plate Number")}
              <span className="plate-sort-icons" aria-hidden="true">
                {plateSort !== "DESC" && <svg><use href={`${sprite}#chevron-up`} /></svg>}
                {plateSort !== "ASC" && <svg><use href={`${sprite}#chevron-down`} /></svg>}
              </span>
            </button>
          ) : getLocalizedString("plate_number", "Plate Number")}
        </div>
        <div className="qi-list-view_column speed" title={getLocalizedString("speed", "Speed")}>
          {getLocalizedString("speed", "Speed")}
        </div>
        <div
          className="qi-list-view_column ignition-status"
          title={getLocalizedString("ignition", "Ignition")}
        >
          {getLocalizedString("ignition", "Ignition")}
        </div>
      </header>
    );
  };

  return (
    <>
      <MapViewFlyOut
        data={sortedDataDisplay ? vehiclesData : coreDevices?.data || []}
        setSelectedRange={setSelectionRange}
        pagination={
          sortedDataDisplay
            ? { ...paginationVehicles, count: totalCountVehicles }
            : { ...pagination, count: coreDevices?.total_count }
        }
        error={error}
        highlight={highlight}
        setHighlight={setHighlight}
        setDockAlign={setDockAlign}
        setShowDetails={setShowDetails}
        removeLayerOnClose={removeLayerOnClose}
        setDeviceId={setDeviceId}
        setShowTrack={setShowTrack}
        simpleSearch={simpleSearch}
        selectedPage={"Vehicles"}
        title={getLocalizedString("vehicles", "Vehicles")}
        currentTab={currentTab}
        setselectedVehiclePlate={setselectedVehiclePlate}
        showPontOnMap={showPontOnMap}
        dockAlign={dockAlign}
        setDetails={setDetails}
        setSimpleSearch={setSimpleSearch}
        setMapExpand={setMapExpand}
        listType={"Vehicles"}
        isLoading={isLoading}
        search_by_message={getLocalizedString(
          "search_by_plate_no_device_imei",
          "Plate No, Device IMEI, Device Name",
        )}
        getHeaderList={getHeaderList}
        setSortedDataDisplay={setSortedDataDisplay}
        sortedDataDisplay={sortedDataDisplay}
        setPage={setPage}
        setPageVehicles={setPageVehicles}
        isRefreshing={isRefreshing}
        formatLastUpdated={formatLastUpdated}
        deviceId={selectedRowId}
        isAutoRefreshPaused={Boolean(simpleSearch || (sortedDataDisplay && plateSort))}
        collapsed={selectedRowId}
      >
        <Scrollbars>
          <ListCard
            data={sortedDataDisplay ? vehiclesData : coreDevices?.data || []}
            cardType="Vehicles"
            onRowClick={onRowClick}
            highlight={highlight}
            setHighlight={setHighlight}
            selectedRowId={selectedRowId}
            mapData={mapData}
            sortedDataDisplay={sortedDataDisplay}
            formatLastUpdated={formatLastUpdated}
            telemetry={telemetry}
          />
        </Scrollbars>
      </MapViewFlyOut>
    </>
  );
};
